import { render, staticRenderFns } from "./VacancyCandidatesKanbanVideoCall.vue?vue&type=template&id=cbc5ffae&scoped=true&"
import script from "./VacancyCandidatesKanbanVideoCall.vue?vue&type=script&lang=js&"
export * from "./VacancyCandidatesKanbanVideoCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc5ffae",
  null
  
)

/* custom blocks */
import block0 from "./VacancyCandidatesKanbanVideoCall.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./VacancyCandidatesKanbanVideoCall.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VDialog})
